import { cn } from "@/lib/utils";

type StackBelow = "md" | "never" | "sm";

const AXIS: Record<StackBelow, string> = {
  md: "flex-col divide-y md:flex-row md:divide-x md:divide-y-0",
  never: "flex-row divide-x",
  sm: "flex-col divide-y sm:flex-row sm:divide-x sm:divide-y-0",
};

interface DemoSplitProps {
  children: React.ReactNode;
  className?: string;
  stackBelow?: StackBelow;
}

export default function DemoSplit({
  children,
  className,
  stackBelow = "md",
}: DemoSplitProps) {
  return (
    <div
      className={cn(
        "flex w-full divide-preview-border",
        AXIS[stackBelow],
        className
      )}
    >
      {children}
    </div>
  );
}
